import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgHeartStraightFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.25 10.719a6.303 6.303 0 0 1-1.86 4.484l-9.767 9.912a.875.875 0 0 1-1.246 0l-9.768-9.912a6.346 6.346 0 1 1 8.97-8.98L14 7.553l1.432-1.334a6.344 6.344 0 0 1 10.818 4.5Z" />
  </svg>
);
export default SvgHeartStraightFill;
